import { __extends, __decorate, __metadata, __param, __spread } from 'tslib';
import { Input, Component, forwardRef, Optional, Renderer2, ElementRef, HostBinding, ViewEncapsulation, ChangeDetectionStrategy, Self, ChangeDetectorRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, NgControl, FormsModule } from '@angular/forms';
import { UkBaseFormControl, UK_ALIGMENT, UkFormGroupComponent, UIKitCommonModule } from '@uikit/components/common';
import { UkFormControlsModule } from '@uikit/components/uk-form-controls';

var NO_FN = function () {
    // Placeholder function
};
var UkCheckboxComponent = /** @class */ (function (_super) {
    __extends(UkCheckboxComponent, _super);
    function UkCheckboxComponent(renderer, elementRef, ngControl) {
        var _this = _super.call(this, ngControl, 'uk-checkbox') || this;
        _this.renderer = renderer;
        _this.elementRef = elementRef;
        _this.onTouched = NO_FN;
        _this.onChange = NO_FN;
        return _this;
    }
    UkCheckboxComponent_1 = UkCheckboxComponent;
    Object.defineProperty(UkCheckboxComponent.prototype, "inputId", {
        get: function () {
            return "chk-" + this.id;
        },
        enumerable: true,
        configurable: true
    });
    // ControlValueAccessor interface implementation
    UkCheckboxComponent.prototype.writeValue = function (value) {
        this.renderer.setProperty(this.elementRef, 'checked', value === this.elementRef.nativeElement.value);
    };
    UkCheckboxComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    UkCheckboxComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    var UkCheckboxComponent_1;
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkCheckboxComponent.prototype, "id", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkCheckboxComponent.prototype, "name", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkCheckboxComponent.prototype, "class", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UkCheckboxComponent.prototype, "value", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkCheckboxComponent.prototype, "tabindex", void 0);
    __decorate([
        Input('aria-label'),
        __metadata("design:type", String)
    ], UkCheckboxComponent.prototype, "ariaLabel", void 0);
    __decorate([
        Input('aria-labelledby'),
        __metadata("design:type", String)
    ], UkCheckboxComponent.prototype, "ariaLabelledby", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], UkCheckboxComponent.prototype, "checked", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], UkCheckboxComponent.prototype, "disabled", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], UkCheckboxComponent.prototype, "required", void 0);
    UkCheckboxComponent = UkCheckboxComponent_1 = __decorate([
        Component({
            selector: 'uk-checkbox',
            template: "<input #input\r\n  type=\"checkbox\"\r\n  [id]=\"inputId\"\r\n  [checked]=\"checked\"\r\n  [disabled]=\"disabled\"\r\n  [attr.required]=\"required\"\r\n  [tabindex]=\"tabindex\"\r\n  [attr.value]=\"value\"\r\n  [attr.name]=\"name\"\r\n  [attr.class]= \"class\"\r\n  [attr.aria-label]=\"ariaLabel\"\r\n  [attr.aria-labelledby]=\"ariaLabelledby\"\r\n  (click)=\"onChange($event.target.value)\">\r\n<label #label\r\n  [attr.for]=\"inputId\">\r\n  <ng-content></ng-content>\r\n</label>",
            exportAs: 'ukCheckbox',
            providers: [
                {
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: forwardRef(function () { return UkCheckboxComponent_1; }),
                    multi: true,
                },
            ]
        }),
        __param(2, Optional()),
        __metadata("design:paramtypes", [Renderer2,
            ElementRef,
            NgControl])
    ], UkCheckboxComponent);
    return UkCheckboxComponent;
}(UkBaseFormControl));

var UkCheckboxGroupComponent = /** @class */ (function (_super) {
    __extends(UkCheckboxGroupComponent, _super);
    function UkCheckboxGroupComponent(ngControl, cdRef) {
        var _this = _super.call(this, ngControl, 'checkbox-group', cdRef) || this;
        _this.aligment = UK_ALIGMENT.Vertical;
        _this.role = 'group';
        return _this;
    }
    UkCheckboxGroupComponent_1 = UkCheckboxGroupComponent;
    Object.defineProperty(UkCheckboxGroupComponent.prototype, "horizontal", {
        get: function () { return this.aligment === UK_ALIGMENT.Horizontal; },
        enumerable: true,
        configurable: true
    });
    UkCheckboxGroupComponent.prototype.onCheckboxChanged = function (el) {
        var parentElement = el.parentElement.parentElement;
        var options = parentElement.children;
        var values = [];
        for (var i = 0; i < options.length; i++) {
            // Get input type checkbox of div with class 'uk-checkbox-group__item'
            var input = options.item(i).children.item(0);
            if (input.checked) {
                values = __spread(values, [input.value]);
            }
        }
        this.value = __spread(values);
    };
    var UkCheckboxGroupComponent_1;
    __decorate([
        Input(), HostBinding('attr.aria-labelledby'),
        __metadata("design:type", Object)
    ], UkCheckboxGroupComponent.prototype, "ariaLabelledby", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UkCheckboxGroupComponent.prototype, "aligment", void 0);
    __decorate([
        HostBinding('class.uk-checkbox-group'),
        HostBinding('attr.role'),
        __metadata("design:type", Object)
    ], UkCheckboxGroupComponent.prototype, "role", void 0);
    __decorate([
        HostBinding('class.horizontal'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], UkCheckboxGroupComponent.prototype, "horizontal", null);
    UkCheckboxGroupComponent = UkCheckboxGroupComponent_1 = __decorate([
        Component({
            selector: 'uk-checkbox-group',
            template: "<div class=\"uk-checkbox-group__item\" *ngFor=\"let opt of _items; let i = index\" >\r\n    <input [id]=\"opt.id\" type=\"checkbox\" [value]=\"opt.value\" [name]=\"id\" (change)=\"onCheckboxChanged($event.target)\"\r\n    [attr.checked]=\"value === opt.value ? '' : null\"/>\r\n    <label [for]=\"opt.id\">\r\n        {{ opt.viewValue }}\r\n    </label>\r\n</div>",
            encapsulation: ViewEncapsulation.None,
            changeDetection: ChangeDetectionStrategy.OnPush,
            providers: [{
                    provide: UkBaseFormControl,
                    useExisting: forwardRef(function () { return UkCheckboxGroupComponent_1; })
                }]
        }),
        __param(0, Self()), __param(0, Optional()),
        __metadata("design:paramtypes", [NgControl, ChangeDetectorRef])
    ], UkCheckboxGroupComponent);
    return UkCheckboxGroupComponent;
}(UkFormGroupComponent));

var UkCheckboxModule = /** @class */ (function () {
    function UkCheckboxModule() {
    }
    UkCheckboxModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                FormsModule,
                UIKitCommonModule,
                UkFormControlsModule
            ],
            declarations: [
                UkCheckboxComponent,
                UkCheckboxGroupComponent
            ],
            exports: [
                UkCheckboxComponent,
                UkCheckboxGroupComponent
            ]
        })
    ], UkCheckboxModule);
    return UkCheckboxModule;
}());

export { UkCheckboxModule, UkCheckboxComponent as ɵa, UkCheckboxGroupComponent as ɵb };
//# sourceMappingURL=uikit-components-uk-checkbox.js.map
